module.exports = __webpack_public_path__ + "static/media/close.433dbba8.svg";